<template lang="pug">
  .cart-totals
    p.xs-mb-150m.xs-f-small.max-at-tweak Subtotal:&nbsp;
      span.float-right.semi-bold.xs-f-small.max-at-tweak(data-mr-ass="totals-subtotal") {{subtotal | currency}}

    p.xs-mb-150m.xs-f-small.max-at-tweak(v-if="shippingRequired") Estimated Shipping:&nbsp;
      span.float-right.semi-bold.xs-f-small.max-at-tweak {{estimatedShipping | freeCurrency}}

    site-messages.xs-mb-150m(topics="cart" v-slot="s")
      template(v-for="message in s.messages" :index="message.id")
        .site-message(v-html="message.message")

    p.xs-mb-50m.xs-f-small.max-at-tweak Promotions:

    CartPromoItem(v-for="promo in appliedPromos" :key="promo.id" :promo="promo")

    p.xs-mb-150m.xs-f-small.max-at-tweak(v-if="creditBalance") Credits (Balance: {{creditBalance | currency}}):&nbsp;
      span.float-right.semi-bold.xs-f-small.max-at-tweak {{credits | currency}}

    template(v-if="paymentDetails")
      .payment-detail.xs-mb-100m(v-for="details in paymentDetails")
        button.remove.btn-reset.icon-x-full.color-font-subtle.xs-f-small.max-at-tweak(v-if="details.canRemove && details.promoId" @click="openRemovePromoModal({ promoId: details.promoId })")
          span.ada-tooltip remove
        p.xs-f-small.max-at-tweak {{details.display}}
          span.xs-f-small.max-at-tweak(v-if="details.showBalance" data-mr-ass="credits-unused")  (Balance: {{details.unused | currency}})
          | :
          span.float-right.semi-bold.xs-f-small.max-at-tweak(data-mr-ass="credits-used") -{{details.amount | currency}}

    p.xs-mb-150m.xs-f-small.max-at-tweak(v-if="giftCard") Balance will be applied during checkout.

    CartApplyPromoForm

    template(v-if="tax && taxPercent")
      p.xs-mb-150m.xs-f-small.max-at-tweak Tax ({{taxPercent}}&#37;):&nbsp;
        span.float-right.semi-bold.xs-f-small.max-at-tweak {{tax | currency}}
      p.xs-mb-150m.xs-f-small.max-at-tweak Total after tax:&nbsp;
        span.float-right.semi-bold.xs-f-small.max-at-tweak {{totalAfterPayment | currency}}

    template(v-else)
      p.xs-mb-150m.xs-f-small.max-at-tweak Total before tax:&nbsp;
        span.float-right.semi-bold.xs-f-small.max-at-tweak(data-mr-ass="totals-total") {{totalBeforeTax | currency}}

    sticky-wrap.checkout-cta(stop-at="footer")
      .cta-wrap.text-center
        button.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(@click="showCartSelectedPaymentMethodModal" data-mr-ass="checkout") secure checkout
        button.btn-reset.mt-10.mb-10(@click="showCartSelectedPaymentMethodModal" aria-label="show checkout options")
          .checkout-icons

</template>

<script>
  import { mapState, mapActions } from 'vuex';

  import CartPromoItem from "./CartPromoItem/CartPromoItem";
  import CartApplyPromoForm from "./CartApplyPromoForm/CartApplyPromoForm";

  export default {
    name: "CartTotals",

    components: {
      CartApplyPromoForm,
      CartPromoItem
    },

    inject: ['getObjProperty'],

    computed: {
      ...mapState('cart', ['cart']),

      subtotal() {
        return this.getObjProperty(this, 'cart.totals.displaySubtotal');
      },

      shippingRequired() {
        var isRequired = false;

        if (this.cart && this.cart.items) {
          isRequired = this.cart.items.some(item => !item.giftCard);
        }

        return isRequired;
      },

      hasFreeShipping() {
        var freeShipping = false;

        if (this.appliedPromos && this.appliedPromos.length) {
          this.appliedPromos.forEach((promo) => {
            if (promo.offers) {
              promo.offers.forEach((offer) => {
                if (offer.type == "freeShipping" && offer.shippingTypeCode == this.getObjProperty(this, 'cart.shippingMethods.selected.code')) {
                  freeShipping = true;
                }
              });
            }
          });
        }

        return freeShipping;
      },

      estimatedShipping() {
        if (this.hasFreeShipping) {
          return 0;
        } else {
          return this.getObjProperty(this, 'cart.shippingMethods.selected.price');
        }
      },

      appliedPromos() {
        return this.getObjProperty(this, 'cart.totals.appliedPromos');
      },

      creditBalance() {
        return this.getObjProperty(this, 'cart.totals.creditsBalance');
      },

      credits() {
        return this.getObjProperty(this, 'cart.totals.credits');
      },

      paymentDetails() {
        return this.getObjProperty(this, 'cart.totals.paymentDetails');
      },

      giftCard() {
        return this.getObjProperty(this, 'cart.totals.paymentDetails.giftCard');
      },

      tax() {
        return this.getObjProperty(this, 'cart.totals.tax');
      },

      taxPercent() {
        return this.getObjProperty(this, 'cart.totals.taxPercent');
      },

      totalBeforeTax() {
        return this.getObjProperty(this, 'cart.totals.totalBeforeTax');
      },

      totalAfterPayment() {
        return this.getObjProperty(this, 'cart.totals.totalAfterPayment');
      }
    },

    methods: {
      ...mapActions('modal', ['showModal']),
      ...mapActions('cart', ['openRemovePromoModal']),

      showCartSelectedPaymentMethodModal() {
        this.showModal({
          component: './Cart/CartSelectPaymentMethodModal'
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .cart-totals
    border 1px solid color-fog-light
    padding 1.5em

    .checkout-icons
      display inline-block
      background url("/images/checkout-flow/payment-method-icons.svg") no-repeat
      background-size 100%
      height 2em
      width 10.36em
      margin 0 auto
      text-align center

  @media mq-mobile
    .checkout-cta
      height 7em

      &.fixed
        .cta-wrap
          z-index 100
          position fixed
          padding 1em 0
          left 0
          right 0
          bottom 0
          text-align center
          border-top 1px solid color-gray-triple-nines
          background-color color-gray-light
          opacity 100
          transition(opacity 300ms ease-in-out)

          .mr-btn
            width 21em
            margin 0 auto

      &.fixed.stopped
        .cta-wrap
          opacity 0
          pointer-events none

</style>
